import { Link } from "react-router-dom";

const ITEMS = [
  "短剧出海：本地化改编才是真门槛",
  "综艺剪辑如何决定人物弧光",
  "一条爆料的核查路径",
  "应援经济的成本账本",
  "电影宣发的定档博弈",
  "算法调头后的创作者生态",
  "直播舆情黄金一小时",
  "音乐节票价与体验的落差",
];

export default function HotTicker() {
  return (
    <section aria-label="今日热榜" className="marquee-wrap overflow-hidden border-y border-background-200 bg-foreground-950">
      <div className="mx-auto flex max-w-editorial items-center gap-4 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2 py-3 font-label text-xs font-medium tracking-widest text-accent-400">
          <i className="ri-flashlight-fill" aria-hidden="true"></i>
          今日热榜
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8 py-3">
            {[...ITEMS, ...ITEMS].map((item, index) => (
              <Link
                key={`${item}-${index}`}
                to="/insights"
                className="flex shrink-0 items-center gap-2 whitespace-nowrap text-sm text-background-100/85 transition-colors hover:text-accent-400"
              >
                <span className="h-1 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
                {item}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}